import React from 'react'

function CommonCourseComponents({ degree }) {
  if (degree) {
    switch (degree) {
      case "Bachelor’s Degree":
      case "4":
        return <div className="course-title degree-type degree-bachelor">
          <span title="Bachelor’s Degree" className="name"><i className="fas fa-graduation-cap" />Bachelor’s Degree</span>
        </div>
      case "Higher Certificate":
      case "3":
        return <div className="course-title degree-higher">
          <span title="Higher Certificate" className="name"><i className="fas fa-file-certificate" />Higher Certificate</span>
        </div>
      case "Diploma":
      case "2":
        return <div className="course-title degree-diploma">
          <span title="Diploma" className="name"><i className="fas fa-certificate" />Diploma</span>
        </div>
      case "National Certificate":
      case "1":
      case "Certificate":
        return <div className="course-title degree-national">
          <span title="National Certificate" className="name"><i className="fas fa-award" />National Certificate</span>
        </div>
      case "Master Certificate":
        return <div className="course-title degree-master">
          <span title="Master Certificate" className="name"><i className="fas fa-university" />Master Certificate</span>
        </div>
      case "Occupational Certificate":
        return <div className="course-title degree-occupational">
          <span title="Occupational Certificate" className="name"><i className="fas fa-user-graduate" />Occupational Certificate</span>
        </div>
      case "Honours Degree":
        case "5" :
        return <div className="course-title degree-honours">
          <span title="Honours Degree" className="name"><i className="fas fa-medal" />Honours Degree</span>
        </div>
      case "Learning Path":
      case "7":
        return <div className="course-title degree-learning">
          <span title="Learning Path" className="name"><i className="fas fa-route" />Learning Path</span>
        </div>
      case "Master’s Degree":
        return <div className="course-title degree-master">
          <span title="Master’s Degree" className="name"><i className="fas fa-university" />Master’s Degree</span>
        </div>
      default:
        return <div className="course-title degree-learning">
        <span title="name" className="name">N/A</span>
      </div>
    }
  }
  else {
    return null
  }
}
export default CommonCourseComponents


export function ProgramIcons({ degree }) {
  if (degree) {
    switch (degree) {
      case "Bachelor’s Degree":
      case "4":
        return <i className="fas fa-graduation-cap" title='Bachelor’s Degree'/>
      case "Higher Certificate":
      case "3":
        return <i className="fas fa-file-certificate" title='Higher Certificate'/>
      case "Diploma":
      case "2":
        return <i className="fas fa-certificate" title='Diploma'/>
      case "National Certificate":
      case "1":
      case "Certificate":
        return <i className="fas fa-award" title='National Certificate'/>
      case "Master Certificate":
        return <i className="fas fa-university" title='Master Certificate'/>
      case "Occupational Certificate":
        return <i className="fas fa-user-graduate" title='Occupational Certificate'/>
      case "Honours Degree":
      case "5":
        return <i className="fas fa-medal" title='Honours Degree'/>
      case "Learning Path":
      case "7":
        return <i className="fas fa-route" title='Learning Path'/>
      case "Master’s Degree":
        return <i className="fas fa-university" title='Master’s Degree'/>
      default:
        return "N/A"
    }
  }
  else {
    return null
  }
}
